import "./chunk-J43GMYXM.js";

// node_modules/dlv/dist/dlv.es.js
function dlv_es_default(t, e, l, n, r) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)
    t = t ? t[e[n]] : r;
  return t === r ? l : t;
}

// node_modules/templite/dist/templite.mjs
var RGX = /{{(.*?)}}/g;
function templite_default(str, mix) {
  return str.replace(RGX, (x, key, y) => {
    x = 0;
    y = mix;
    key = key.trim().split(".");
    while (y && x < key.length) {
      y = y[key[x++]];
    }
    return y != null ? y : "";
  });
}

// node_modules/rosetta/dist/index.mjs
function dist_default(obj) {
  var locale = "", tree = obj || {};
  return {
    set(lang, table) {
      tree[lang] = Object.assign(tree[lang] || {}, table);
    },
    locale(lang) {
      return locale = lang || locale;
    },
    table(lang) {
      return tree[lang];
    },
    t(key, params, lang) {
      var val = dlv_es_default(tree[lang || locale], key, "");
      if (typeof val === "function")
        return val(params);
      if (typeof val === "string")
        return templite_default(val, params);
      return val;
    }
  };
}
export {
  dist_default as default
};
//# sourceMappingURL=rosetta.js.map
